import React from 'react'
import bugsnag from '@bugsnag/js'
import { Env } from '@morningtrain/helpers'

export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
    this.bugsnag_client = null
  }

  connect () {
    if (this.bugsnag_client === null) {
      const bugsnag_key = Env.get('bugsnag.key', null)
      const notify_stages = Env.get('bugsnag.notify_stages', []).filter(e => !!e)
      const current_stage = Env.get('environment')

      if (bugsnag_key !== null && notify_stages.indexOf(current_stage) > -1) {
        this.bugsnag_client = bugsnag({
          apiKey: bugsnag_key,
          user: Env.get('user')
        })
      }
    }

    return this.bugsnag_client
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch (error, info) {
    // You can also log the error to an error reporting service
    console.error('Cought error', error, info)
    // logErrorToMyService(error, info);
    this.connect()
    if (this.bugsnag_client) {
      console.log('notifying error')
      this.bugsnag_client.notify(error, info)
    }
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <p className='red'>Der opstod en fejl</p>
    }

    return (
      <>
        {this.props.children}
      </>
    )
  }
}
